<template>
  <!--
    Standard dialog header for all modals. See DESIGN_GUIDELINES.md.
    Registered globally in main.js — no import required.
  -->
  <v-toolbar flat dense :color="color" dark class="flex-grow-0 modal-header">
    <v-icon v-if="icon" left>{{ icon }}</v-icon>
    <v-toolbar-title class="text-subtitle-1 font-weight-medium">
      {{ title }}
    </v-toolbar-title>
    <span v-if="subtitle" class="text-caption ml-2 white--text text--lighten-4">
      {{ subtitle }}
    </span>
    <v-chip
      v-if="chip"
      small
      label
      color="white"
      text-color="primary"
      class="ml-3 font-weight-medium"
    >
      <v-icon v-if="chipIcon" x-small left>{{ chipIcon }}</v-icon>
      {{ chip }}
    </v-chip>
    <v-spacer></v-spacer>
    <slot name="actions"></slot>
    <v-btn v-if="closable" icon @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "ModalHeader",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    chip: { type: String, default: "" },
    chipIcon: { type: String, default: "" },
    color: { type: String, default: "primary" },
    closable: { type: Boolean, default: true },
  },
};
</script>
